module.exports = __webpack_public_path__ + "img/wflow.7f840642.png";